import {useNavigate, useRouteError} from 'react-router-dom';
import SpinnerOverlay from './LoaderOverlay';

/**
 * Error boundary for router transitions to prevent 404 flash during auth state changes.
 * When the router key changes (forcing remount), React Router briefly shows a 404 error
 * before the new routes are registered. This component displays a loading spinner instead
 * of the error during that brief transition.
 */
const RouterErrorBoundary = () => {
    const error = useRouteError() as { status?: number; statusText?: string; internal?: boolean };
    const navigate = useNavigate();

    // During router remount (key change), React Router throws a 404 error briefly
    // Show spinner instead of error page during this transition
    if (error?.status === 404 && error?.internal) {
        return <SpinnerOverlay showLoader={true}/>;
    }

    const handleNavigateHome = () => {
        navigate('/', {replace: true});
    };

    return (
        <div className="h-100 d-flex flex-column align-items-center justify-content-center">
            <h2>Unexpected Application Error!</h2>
            <h3>{error?.status} {error?.statusText}</h3>
            <button
                onClick={handleNavigateHome}
                className="btn btn-primary mt-4"
            >
                Zurück zur Startseite
            </button>
        </div>
    );
};

export default RouterErrorBoundary;